import {React } from 'react'
import "../styles/home.css"
import main from "../images/sfondo.JPG"  // foto direttivo da cambiare

const Home = () => {
  return (
    <div className='Home'>
      <div className="nameAndPic">
        <div className='name'>
          <div>
            <div className='headline'>
              <h1 className="slide-in">Il Movimento Studentesco per l'Organizzazione Internazionale</h1>
            </div>
            <p>È la Sezione giovanile ed universitaria della
              Società Italiana per l'Organizzazione Internazionale (S.I.O.I.)</p>
          </div>
        </div>
        <img src={main} alt="" className='mainImage'/>
      </div>
      <div className='presentazione'>
        <h1>M.S.O.I. Torino</h1>
        <p>è il comitato locale M.S.O.I. situato a Torino, con sede al
           Campus delle Nazioni Unite e che potrai incontrare durante i banchetti
            informativi presso il Campus Luigi Einaudi.  </p>
      </div>
    </div>
  )
}

export default Home
